<script setup lang="ts">
// Step 5 / CTA: launchpad — a rocket rising on a curved trail, with
// sparkle accents. The whole composition tilts toward the bottom-right
// "Create Agent" button.
</script>

<template>
  <div class="relative h-full w-full flex items-center justify-center">
    <svg
      viewBox="0 0 320 220"
      class="h-full w-auto"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="wg-create-rocket" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="rgb(var(--accent))" />
          <stop offset="100%" stop-color="#d946ef" />
        </linearGradient>
        <linearGradient id="wg-create-trail" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stop-color="rgb(var(--accent))" stop-opacity="0" />
          <stop offset="100%" stop-color="rgb(var(--accent))" stop-opacity="0.8" />
        </linearGradient>
      </defs>

      <!-- trail -->
      <path
        d="M40 190 C 110 180, 150 130, 220 70"
        stroke="url(#wg-create-trail)"
        stroke-width="3"
        fill="none"
        stroke-linecap="round"
        stroke-dasharray="6 6"
      >
        <animate attributeName="stroke-dashoffset" from="0" to="-24" dur="1.2s" repeatCount="indefinite" />
      </path>

      <!-- rocket (tilted) -->
      <g transform="translate(220 70) rotate(-35)">
        <!-- body -->
        <path
          d="M0 -28 q10 0 10 18 v18 h-20 v-18 q0 -18 10 -18 z"
          fill="url(#wg-create-rocket)"
        />
        <!-- window -->
        <circle cy="-6" r="5" fill="white" opacity="0.95" />
        <circle cy="-6" r="2.5" fill="rgb(var(--accent))" />
        <!-- fins -->
        <path d="M-10 8 l-8 12 l8 0 z" fill="#d946ef" opacity="0.85" />
        <path d="M10 8 l8 12 l-8 0 z" fill="#d946ef" opacity="0.85" />
        <!-- flame -->
        <path d="M-6 8 q6 18 12 0 z" fill="#f59e0b">
          <animate attributeName="opacity" values="1;0.5;1" dur="0.35s" repeatCount="indefinite" />
        </path>
      </g>

      <!-- sparkles around -->
      <g fill="rgb(var(--accent))">
        <path d="M70 90 l1.5 4 l4 1.5 l-4 1.5 l-1.5 4 l-1.5 -4 l-4 -1.5 l4 -1.5 z">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2.2s" repeatCount="indefinite" />
        </path>
        <path d="M260 150 l1.8 4.8 l4.8 1.8 l-4.8 1.8 l-1.8 4.8 l-1.8 -4.8 l-4.8 -1.8 l4.8 -1.8 z">
          <animate attributeName="opacity" values="1;0.3;1" dur="2.6s" repeatCount="indefinite" />
        </path>
        <path d="M150 60 l1.2 3.2 l3.2 1.2 l-3.2 1.2 l-1.2 3.2 l-1.2 -3.2 l-3.2 -1.2 l3.2 -1.2 z">
          <animate attributeName="opacity" values="0.6;1;0.6" dur="1.8s" repeatCount="indefinite" />
        </path>
      </g>

      <!-- ground baseline (subtle horizon) -->
      <line x1="20" y1="194" x2="120" y2="194" stroke="rgb(var(--border))" stroke-width="2" stroke-linecap="round" />
    </svg>
  </div>
</template>
